<script>
import PgMerchantNav from '@components/admin/pg-merchant-nav'
import PgMerchantInfo from '@components/admin/pg-merchant-info'
import AdminLayout from '@layouts/admin-main'

export default {
  page: {
    title: 'Admin::PgMerchantView',
    meta: [{ name: 'description', content: 'Admin::PgMerchantView' }],
  },
  components: { AdminLayout, PgMerchantNav, PgMerchantInfo },
}
</script>

<template>
  <AdminLayout>
    <PgMerchantNav></PgMerchantNav>
    <PgMerchantInfo :merchant_seq="$route.params.merchant_seq"></PgMerchantInfo>
  </AdminLayout>
</template>
